import React from "react";
import Dish from "./Dish";
import { useGlobalContext } from "../context";

const Dishes = () => {
  const { dishes } = useGlobalContext();

  return (
    <section className="dishes">
      <h2 className="dishes-header dishes-title">Menu</h2>
      <article className="dishes-list">
        {dishes.map((dish) => {
          return <Dish key={dish.id} dish={dish} />;
        })}
      </article>
    </section>
  );
};

export default Dishes;
